<input type="text" class ="form-control input-box my-0 py-1" [formControl]="typeahead" 
placeholder="{{'ph_place' | translate}}, {{'ph_farm' | translate}}, {{'ph_parish_DIS' | translate}}, {{'ph_municipality' | translate}}, {{'ph_county' | translate}}, {{'ph_country' | translate}}"
(input)="suggest()" value="{{inputFieldText}}" (click)="hideDropDown()">


<div class="suggestDropDown" *ngIf="suggestions.length > 0 && isSuggestDropDownOpen">
  <div *ngFor="let s of suggestions" class = "" (click)="hideDropDown()">
    <div (click)="selectPlace(s.id)" class = "row">
      {{s.name}}
    </div>
  </div>
</div>